module.exports = __webpack_public_path__ + "img/s8-img3.a8d3fbcc.png";